import { Box, styled } from '@mui/material';

export const VersionList = styled('ul')(({ theme }) => ({
  margin: theme.spacing(0)
}));

export const VersionsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  fontSize: '16px'
}));
